import { render } from "./AllCalendarExercises.vue?vue&type=template&id=498d4fb0"
import script from "./AllCalendarExercises.vue?vue&type=script&lang=js"
export * from "./AllCalendarExercises.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__